import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
import "bootstrap/dist/js/bootstrap.bundle.min"; // Import Bootstrap's JavaScript
import { AuthProvider } from "./supabaseClient"; // Import AuthProvider
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Theme.css"; // Import custom theme styles (case-sensitive)
// import { themeColors } from "./Theme"; // Import theme colors for JS usage
import "./index_2.css"; // Import custom theme styles
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </Router>
    </AuthProvider>
  // </React.StrictMode>,
);

// Register the service worker
// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/service-worker.js')
//     .then(registration => {
//       console.log('Service Worker registered with scope:', registration.scope);
//     })
//     .catch(error => {
//       console.error('Service Worker registration failed:', error);
//     });
// }
